export class RoleModel {
    read = false;
    edit = false;
    complete = false;

    static newRead() {
        const res = new RoleModel();
        res.read = true;
        return res;
    }
    static newEdit() {
        const res = new RoleModel();
        res.read = true;
        res.edit = true;
        return res;
    }
    static newComplete() {
        const res = new RoleModel();
        res.read = true;
        res.edit = true;
        res.complete = true;
        return res;
    }
}
